import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'button-close',
	templateUrl: './button-close.component.html',
	styleUrls: ['./button-close.component.scss'],
})
export class ButtonCloseComponent implements OnInit {
	@Output() eventClick = new EventEmitter<any>();

	constructor() 
	{
		// This is intentional
	}

	ngOnInit(): void 
	{
		// This is intentional
	}

	cancel() {
		this.eventClick.emit();
	}
}
